import { createApp } from 'vue';
import './plugins/assets';
import {
  setupAppVersionNotification,
  setupDayjs,
  setupIconifyOffline,
  setupLoading,
  setupNProgress,
  setupPageSpy
} from './plugins';
import { setupStore } from './store';
import { setupRouter } from './router';
import { setupI18n } from './locales';
import { setupDirective } from './directives';
import App from './App.vue';
import { setAppInstance } from './utils/app-context';

async function setupApp() {
  setupLoading();

  setupPageSpy();

  setupNProgress();

  setupIconifyOffline();

  setupDayjs();

  const app = createApp(App);

  // eslint-disable-next-line no-underscore-dangle
  setAppInstance(app._instance);

  setupStore(app);

  await setupRouter(app);

  setupI18n(app);

  setupAppVersionNotification();

  app.mount('#app');

  setupDirective(app);
}

setupApp();
